import "./async.js";
import { c as attr_class, g as attr_style, s as stringify } from "./renderer.js";
function Tooltip($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let {
      trigger,
      content,
      show = false,
      tooltipClass = "",
      onTooltipMouseEnter,
      onTooltipMouseLeave
    } = $$props;
    let tooltipPosition = { left: "", right: "", top: "" };
    $$renderer2.push(`<div class="relative inline-block">`);
    trigger($$renderer2);
    $$renderer2.push(`<!----></div>`);
    if (show) {
      $$renderer2.push("<!--[0-->");
      $$renderer2.push(`<div role="tooltip"${attr_class(`fixed bg-[var(--light-background)] border border-[var(--border-color)] rounded-2xl z-[1000] shadow-xl backdrop-blur-md ${stringify(tooltipClass)}`)}${attr_style("color: var(--text);", {
        left: tooltipPosition.left,
        right: tooltipPosition.right,
        top: tooltipPosition.top
      })}>`);
      content($$renderer2);
      $$renderer2.push(`<!----></div>`);
    } else {
      $$renderer2.push("<!--[-1-->");
    }
    $$renderer2.push(`<!--]-->`);
  });
}
export {
  Tooltip as T
};
